
















import Vue from 'vue'
import { ottoPayAvailable, ottoPayRequest } from '@/utils/ottoPay'
export default Vue.extend({
  props: { outletCode: { type: String, default: '' }, selected: { type: Boolean, default: false } },
  data() { return { available: ottoPayAvailable, loaded: false, busy: false, mid: '', apiKey: '', hasKey: false, enabled: false, environment: '', message: '', requestVersion: 0 } },
  watch: { outletCode() {
    this.requestVersion++
    Object.assign(this, { loaded: false, busy: false, mid: '', apiKey: '', hasKey: false, enabled: false, environment: '', message: '' })
  } },
  beforeDestroy() { this.requestVersion++; this.apiKey = '' },
  methods: {
    async load() {
      const request = ++this.requestVersion
      this.busy = true; this.message = ''; this.apiKey = ''
      try {
        const settings = await ottoPayRequest('credentials-get', { outletCode: this.outletCode })
        if (request === this.requestVersion) { Object.assign(this, settings); this.loaded = true }
      } catch (error) { if (request === this.requestVersion) this.message = error.message } finally { if (request === this.requestVersion) this.busy = false }
    },
    async save() {
      const request = ++this.requestVersion
      this.busy = true; this.message = ''
      try {
        const settings = await ottoPayRequest('credentials-save', { outletCode: this.outletCode, mid: this.mid, apiKey: this.apiKey, enabled: this.enabled })
        if (request === this.requestVersion) { Object.assign(this, settings); this.message = 'H2H settings saved. Payment verification is still required.' }
      } catch (error) { if (request === this.requestVersion) this.message = error.message } finally { if (request === this.requestVersion) { this.apiKey = ''; this.busy = false } }
    }
  }
})
